require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-how-to-write-a-website-specification.json") })
        }
      }, "path---blog-how-to-write-a-website-specification");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-how-to-write-a-website-specification!./.cache/json/blog-how-to-write-a-website-specification.json
// module id = 470
// module chunks = 231608221292675